import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import { DialogContent, Icon, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { emojify } from 'react-emojione';

import Dialog from 'components/Dialog';

const styles = (theme) => ({
  list: {
    padding: 0,
  },
  listContainer: {
    padding: 0,
    height: 209,
    overflowY: 'auto',
  },
  listItem: {
    borderBottom: `1px solid ${theme.custom.palette.colorGrayishBlue}`,
    padding: `${theme.spacing.unit + 6}px ${theme.spacing.unit * 3}px`,
  },
  listItemIconWrapper: {
    marginRight: 0,
  },
  listItemIcon: {
    marginTop: 2,
    fontSize: 16,
  },
  listItemText: {
    color: theme.custom.palette.colorSupportSlate,
    fontSize: 14,
    fontWeight: 500,
  },
  splashContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: 277,
  },
  splashIcon: {
    fontSize: 24,
    textAlign: 'center',
  },
  splashSubtitle: {
    color: theme.custom.palette.colorSupportSlate,
    fontSize: 18,
    fontWeight: 500,
    lineHeight: '40px',
    textAlign: 'center',
  },
  splashTitle: {
    color: theme.palette.text.primary,
    fontSize: 22,
    fontWeight: 600,
    lineHeight: '40px',
    textAlign: 'center',
  },
});

class DialogSwitchAccount extends PureComponent {
  constructor(props) {
    super(props);

    this.renderAccount = this.renderAccount.bind(this);

    this.state = {
      selectedValue: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { open } = this.props;

    if (!open && nextProps.open) this.setState({ selectedValue: false });
  }

  handleMenuItemClick = (account) => {
    const { onSelectAccount } = this.props;

    this.setState({ selectedValue: account });

    onSelectAccount(account);
  };

  renderAccount(account) {
    const { classes } = this.props;

    return (
      <ListItem
        button
        className={classes.listItem}
        key={account._id}
        onClick={() => this.handleMenuItemClick(account._id)}
      >
        <ListItemText classes={{ primary: classes.listItemText }} primary={account.name} />
        <ListItemIcon className={classes.listItemIconWrapper}>
          <Icon className={classes.listItemIcon}>keyboard_arrow_right</Icon>
        </ListItemIcon>
      </ListItem>
    );
  }

  renderAccounts() {
    const { accounts, classes } = this.props;
    const { selectedValue } = this.state;

    if (selectedValue) return;

    return (
      <DialogContent className={classes.listContainer}>
        <List className={classes.list}>{map(accounts, this.renderAccount)}</List>
      </DialogContent>
    );
  }

  renderSplash() {
    const { classes } = this.props;
    const { selectedValue } = this.state;

    if (!selectedValue) return;

    return (
      <DialogContent className={classes.splashContainer}>
        <div className={classes.splashIcon}>{emojify(':wave:', { output: 'unicode' })}</div>
        <div className={classes.splashTitle}>Hang tight</div>
        <div className={classes.splashSubtitle}>Switching accounts...</div>
      </DialogContent>
    );
  }

  render() {
    const { onRequestClose, open } = this.props;

    return (
      <Dialog headerText="Select an account" onClose={onRequestClose} open={open}>
        {this.renderAccounts()}
        {this.renderSplash()}
      </Dialog>
    );
  }
}

DialogSwitchAccount.propTypes = {
  accounts: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onSelectAccount: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default withStyles(styles)(DialogSwitchAccount);
